import React from 'react';

const showToastNotification = async (
  type: 'success' | 'error' | 'info',
  description: string,
  closeToast?: React.RefObject<(() => void) | null>,
) => {
  const { default: toastNotification, dismissToast } = await import(
    /* webpackChunkName: "toastNotification" */ '@/client/components/Toast/ToastNotification'
  );

  if (closeToast) {
    closeToast.current = dismissToast;
  }

  toastNotification({ type, description });
};

export default showToastNotification;
